import { render, staticRenderFns } from "./PatronymicTextField.vue?vue&type=template&id=7f1e064c"
import script from "./PatronymicTextField.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatronymicTextField.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseTextField: require('/builds/medtochka/medtochka-frontend/core/components/Base/BaseTextField.vue').default})
